var explain = {
  接待总数_1 : '今日内所有结算的车辆台次数量',
  预约到店_1:'有过预约且实际在今日到店结算的车辆台次',
  施工工作量分配_1:'系统上派过工且在今日施工完成的台次',
  施工类型_1:'今日结算的各施工类型台次',
  施工进度_1:'今日开单的工单施工进度台次分布',
  车型分布_1:'今日结算的车辆品牌台次分布',
  今日营业额_1:'今日所有结算工单销售金额之和（不含会员卡销售额）',
  今日毛利_1:'今日所有结算工单销售总金额减去销售成本',
  今日客单价_1:'今日所有结算工单销售总金额除以今日结算工单数',
  今日销售成本_1:'今日所有结算工单所含商品的进货价之和',
  会员卡总销售额_1:'今日所有售出会员卡的金额之和',
  消费客户构成_1:'今日所有结算工单对应消费客户属性',
  商品销量_1:'今日各商品大类的销售数量',
  商品销售额_1:'今日各商品大类的销售金额',
  销售毛利品类分布_1:'今日各商品大类的销售毛利',
  会员卡销量_1:'今日各种类会员卡的销售数量',
  会员卡销售额_1:'今日各种类会员卡的销售金额',
  会员卡消费营业额_1:'今日各种类会员卡消费的营业额',
  会员卡退卡数量_1:'今日各种类会员卡退卡的数量',
  会员卡退卡金额_1:'今日各种类会员卡退卡的金额',
  今日采购货值_1:'今日采购商品的总进货价之和',
  今日采购数量_1:'今日采购商品的件数之和',
  采购商品分布_1:'今日采购的各种类商品的进货货值',
  供应商占比_1:'今日采购商品金额按供应商分布',
  供应商供货分布_1:'今日采购的各种类商品按供应商分布',
  今日入库货值_1:'今日采购入库的商品总货值（扣除退货入库及反结算）',
  今日出库货值_1:'今日采购出库的商品总货值（扣除退货及反结算）',
  库存总货值_1:'当前库存总货值',
  商品大类库存数量_1:'按商品大类统计当前库存总数量',
  商品大类库存货值_1:'按商品大类统计当前库存总货值',
  今日新增客户_1:'今日到店新登记入册的客户总数量',
  累计客户总数_1:'截止当前，历史上所有在册的客户数量',
  客户类型构成_1:'截止当前，流失客户与留存客户数量分布（流失客户指超过24个月未到店的老用户）',
  客户性别比例_1:'截止当前，所有在册客户男女比例',
  会员类型占比_1:'截止当前，不同会员卡类型对应的会员数量',
  客户属性分布_1:'截止当前，分别统计个人客户与企业客户的数量',
  客户车辆车型数量_1:'截止当前，所有已结算车辆车型的数量',
  客户车辆行驶里程分布_1:'截止当前，已结算的送修车辆在各个已行驶里程分段区间内的数量统计',
  客户累积消费金额阶梯分布_1:'截止当前，在各个累积消费金额区间内的客户数量统计',
  今日实收_1:'今日实际收款总金额（含线上支付、现金）',
  今日实付_1:'今日实际支付总金额',
  应收_1:'截止当前，实际应收款金额',
  应付_1:'截止当前，实际应付款金额',
  会员卡卡内总余额_1:'截止当前，所有已售会员卡卡内总余额',
  实收名目分布_1:'今日实际收款按不同业务名目统计金额（含线上支付、现金）',
  会员卡未核销权益统计_1:'截止当前，所有已售会员卡未核销权益统计',
  今日优惠券发放金额_1:'今日内所有优惠券发放总金额',
  今日拼团成交金额_1:'今日内所有拼团成交总金额',
  今日秒杀成交金额_1:'今日内所有秒杀成交总金额',
  优惠券发放金额_1:'今日内各种类优惠券发放金额',
  拼团成交金额_1:'今日内各种类拼团活动成交金额',
  秒杀成交金额_1:'今日内各种类秒杀活动成交金额',
  今日优惠券发放数量_1:'今日内所有优惠券发放总数量',
  今日拼团成交单数_1:'今日内所有拼团活动成交总单数',
  今日秒杀成交单数_1:'今日内所有秒杀活动成交总单数',
  优惠券发放分布_1:'今日内各种类优惠券发放数量',
  优惠券核销分布_1:'今日内各种类优惠券核销数量',
  秒杀成交分布_1:'今日内各种类秒杀活动成交数量',
  秒杀核销分布_1:'今日内各种类秒杀核销数量',
  拼团成交分布_1:'今日内各种类拼团活动成交数量',
  拼团核销分布_1:'今日内各种类拼团核销数量',
  会员退卡数量_1:'当日各种类会员卡退卡的数量',
  客单价_2:'当周所有结算工单销售总金额除以当周结算工单数',
  销售成本_2:'当周所有结算工单所含商品的进货价之和',
  营业额趋势_2:'当周内按天统计结算工单销售金额之和（不含会员卡销售额）',
  毛利趋势_2:'当周内按天统计每天的工单销售总金额减去销售成本',
  单日会员卡总销售额_2:'当周内按天统计每天的会员卡销售金额',
  消费客户构成_2:'当周所有结算工单对应消费客户属性',
  商品销量_2:'当周各商品大类的销售数量',
  商品销售额_2:'当周各商品大类的销售金额',
  销售毛利品类分布_2:'当周各商品大类的销售毛利',
  会员卡销量_2:'当周各种类会员卡的销售数量',
  会员卡销售额_2:'当周各种类会员卡的销售金额',
  会员卡消费营业额_2:'当周各种类会员卡消费的营业额',
  单日会员卡销售金额_2:'当周内每天各种类会员卡的销售金额',
  单日会员卡销费的营业额_2:'当周内每天各种类会员卡消费的营业额',
  单日会员卡退卡金额_2:'当周内每天各种类会员卡退卡的金额',
  会员退卡数量_2:'当周各种类会员卡退卡的数量',
  会员卡退卡金额_2:'当周各种类会员卡退卡的金额',
  采购商品分布_2:'当周采购的各种类商品的进货货值',
  供应商占比_2:'当周采购商品金额按供应商分布',
  供应商供货分布_2:'当周采购的各种类商品按供应商分布',
  入库货值_2:'当周采购入库的商品总货值（扣除退货入库及反结算）',
  出库货值_2:'当周采购出库的商品总货值（扣除退货及反结算）',
  入库货值趋势_2:'当周按天统计采购入库的商品总货值（扣除退货入库及反结算）',
  出库货值趋势_2:'当周按天统计采购出库的商品总货值（扣除退货及反结算）',
  新增客户_2:'当周周一之前未在册、当周内新入册的客户排重总和',
  实收_2:'当周实际收款总金额（含线上支付、现金）',
  实付_2:'当周实际支付总金额（含线上支付、现金）',
  实收名目分布_2:'当周实际收款按不同业务名目统计金额（含线上支付、现金）',
  优惠券发放金额_2:'当周内所有优惠券发放总金额',
  拼团成交金额_2:'当周内所有拼团成交总金额',
  秒杀成交金额_2:'当周内所有秒杀成交总金额',
  优惠券发放金额_2:'当周内各种类优惠券发放金额',
  拼团成交金额_2:'当周内各种类拼团活动成交金额',
  秒杀成交金额_2:'当周内各种类秒杀活动成交金额',
  优惠券发放数量_2:'当周内所有优惠券发放总数量',
  拼团成交单数_2:'当周内所有拼团活动成交总单数',
  秒杀成交单数_2:'当周内所有秒杀活动成交总单数',
  优惠券发放分布_2:'当周内各种类优惠券发放数量',
  单日优惠券发放数量_2:'当周内每天各种类优惠券发放数量',
  优惠券核销分布_2:'当周内各种类优惠券核销数量',
  单日优惠券核销数量_2:'当周内每天各种类优惠券核销数量',
  秒杀成交分布_2:'当周内各种类秒杀活动成交数量',
  单日秒杀成交数量_2:'当周内每天各种类秒杀活动成交数量',
  秒杀核销分布_2:'当周内各种类秒杀核销数量',
  单日秒杀核销数量_2:'当周内每天各种类秒杀核销数量',
  拼团成交分布_2:'当周内各种类拼团活动成交数量',
  单日拼团成交数量_2:'当周内每天各种类拼团活动数量',
  拼团核销分布_2:'当周内各种类拼团核销数量',
  单日拼团核销数量_2:'当周内每天各种类拼团核销数量',
  接待总数_3:'本月内所有结算的车辆台次数量',
  预约到店_3:'有过预约且实际在本月内到店结算的车辆台次',
  施工工作量分配_3:'系统上派过工且在本月内施工完成的台次',
  施工类型_3:'本月内结算的各施工类型台次',
  施工进度_3:'本月内开单的工单施工进度台次分布',
  车型分布_3:'本月结算的车辆品牌台次分布',
  客单价_3:'当月所有结算工单销售总金额除以当月结算工单数',
  销售成本_3:'当月所有结算工单所含商品的进货价之和',
  营业额趋势_3:'当月内按天统计结算工单销售金额之和（不含会员卡销售额）',
  毛利趋势_3:'当月内按天统计每天的工单销售总金额减去销售成本',
  单日会员卡总销售额_3:'当月内按天统计每天的会员卡销售金额',
  消费客户构成_3:'当月所有结算工单对应消费客户属性',
  商品销量_3:'当月各商品大类的销售数量',
  商品销售额_3:'当月各商品大类的销售金额',
  销售毛利品类分布_3:'当月各商品大类的销售毛利',
  会员卡销量_3:'当月各种类会员卡的销售数量',
  会员卡销售额_3:'当月各种类会员卡的销售金额',
  会员卡销费营业额_3:'当月各种类会员卡消费的营业额',
  单日会员卡销售金额_3:'当月内每天各种类会员卡的销售金额',
  单日会员卡销费的营业额_3:'当月内每天各种类会员卡消费的营业额',
  单日会员卡退卡金额_3:'当月内每天各种类会员卡退卡的金额',
  会员退卡数量_3:'当月各种类会员卡退卡的数量',
  会员卡退卡金额_3:'当月各种类会员卡退卡的金额',
  采购商品分布_3:'当月采购的各种类商品的进货货值',
  供应商占比_3:'当月采购商品金额按供应商分布',
  供应商供货分布_3:'当月采购的各种类商品按供应商分布',
  入库货值_3:'当月采购入库的商品总货值（扣除退货入库及反结算）',
  出库货值_3:'当月采购出库的商品总货值（扣除退货及反结算）',
  入库货值趋势_3:'当月按天统计采购入库的商品总货值（扣除退货入库及反结算）',
  出库货值趋势_3:'当月按天统计采购出库的商品总货值（扣除退货及反结算）',
  新增客户_3:'当月1号之前未在册、当月内新入册的客户排重总和',
  实收_3:'当月实际收款总金额（含线上支付、现金）',
  实付_3:'当月实际支付总金额（含线上支付、现金）',
  实收名目分布_3:'当月实际收款按不同业务名目统计金额（含线上支付、现金）',
  优惠券发放金额_3:'当月内所有优惠券发放总金额',
  拼团成交金额_3:'当月内所有拼团成交总金额',
  秒杀成交金额_3:'当月内所有秒杀成交总金额',
  优惠券发放金额_3:'当月内各种类优惠券发放金额',
  拼团成交金额_3:'当月内各种类拼团活动成交金额',
  秒杀成交金额_3:'当月内各种类秒杀活动成交金额',
  优惠券发放数量_3:'当月内所有优惠券发放总数量',
  拼团成交单数_3:'当月内所有拼团活动成交总单数',
  秒杀成交单数_3:'当月内所有秒杀活动成交总单数',
  优惠券发放分布_3:'当月内各种类优惠券发放数量',
  单日优惠券发放数量_3:'当月内每天各种类优惠券发放数量',
  优惠券核销分布_3:'当月内各种类优惠券核销数量',
  单日优惠券核销数量_3:'当月内每天各种类优惠券核销数量',
  秒杀成交分布_3:'当月内各种类秒杀活动成交数量',
  单日秒杀成交数量_3:'当月内每天各种类秒杀活动成交数量',
  秒杀核销分布_3:'当月内各种类秒杀核销数量',
  单日秒杀核销数量_3:'当月内每天各种类秒杀核销数量',
  拼团成交分布_3:'当月内各种类拼团活动成交数量',
  单日拼团成交数量_3:'当月内每天各种类拼团活动数量',
  拼团核销分布_3:'当月内各种类拼团核销数量',
  单日拼团核销数量_3:'当月内每天各种类拼团核销数量',
  新增客户_4:'当年1月1号之前未在册、当年内新入册的客户排重总和',
  老客消费频次_4:'当年所有开单结算客户消费总订单数除以排重用户数再除以12',
  客户流失率统计_4:'以当月为起始往前推算两年，以在前半段（前12个月）内到店消费的排重客户，查找其中有多少客户在后半段（后12个月）有再次到店，后者除以前者即为该月的客户流失率',
}
export default {
  explain,
}


//////////////////
// WEBPACK FOOTER
// ./static/js/calculationExplain.js
// module id = null
// module chunks = 